<template>
  <v-container fluid>
    <h1 class="headline">{{ $t('pages.platformrevenues.title') }}</h1>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-layout row wrap>
      <v-flex xs12 sm4 class="mb-3">
        <dashboard-purchases-sum :params="params"></dashboard-purchases-sum>
      </v-flex>
      <v-flex xs12 sm8 class="mb-3">
        <dashboard-purchases :params="params"></dashboard-purchases>
      </v-flex>
      <v-flex xs12 sm8 class="mb-3">
        <offer-repartition :params="params"></offer-repartition>
      </v-flex>
      <v-flex xs12 sm4 class="mb-3">
        <offer-type-repartition :params="params"></offer-type-repartition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import withInterval from '@/mixins/withInterval'
  import { DashboardPurchases, OfferRepartition, OfferTypeRepartition, DashboardPurchasesSum } from '@/components/dashboard'
  export default {
    components: {
      DashboardPurchases,
      DashboardPurchasesSum,
      OfferRepartition,
      OfferTypeRepartition
    },
    mixins: [withInterval]
  }
</script>




// WEBPACK FOOTER //
// src/pages/PlatformRevenues.vue